/*
 * Carte KPI — deux variantes :
 *  - dark : cellule du bandeau sombre (#1F2937), comme l'ancien header du dashboard
 *  - light : carte blanche pour le corps de page
 */
const KpiCard = ({ label, value, sub, accent, loading, variant = "dark", className = "" }) => {
  if (variant === "light") {
    return (
      <div className={`bg-white rounded-2xl border border-slate-200/60 shadow-sm px-6 py-5 ${className}`}>
        <p className="text-xs font-medium tracking-wide uppercase mb-2 text-slate-400">{label}</p>
        <p
          className="text-3xl leading-none"
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontWeight: 500,
            color: loading ? "#CBD5E1" : (accent ?? "#0F172A"),
          }}
        >
          {loading ? "…" : value}
        </p>
        {sub && <p className="text-xs mt-1.5 text-slate-400">{sub}</p>}
      </div>
    );
  }

  return (
    <div className={`px-6 py-5 ${className}`} style={{ backgroundColor: "#1F2937" }}>
      <p className="text-xs font-medium tracking-wide uppercase mb-2" style={{ color: "#6B7280" }}>
        {label}
      </p>
      <p
        className="text-3xl sm:text-4xl leading-none"
        style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontWeight: 500,
          color: loading ? "#374151" : (accent ?? "#F9F6F0"),
        }}
      >
        {loading ? "…" : value}
      </p>
      {sub && <p className="text-xs mt-1.5" style={{ color: "#4B5563" }}>{sub}</p>}
    </div>
  );
};

export default KpiCard;
